// react
import React, { Component } from 'react';
import EmptyState from '../shared/EmptyState';

// third-party
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { 
    Table,
    Media,
    Card,
    Badge,
    Row,
    CardTitle,
    Form,
    Col,
    CardBody,
    CardHeader,
} from 'reactstrap';
// application
import Pagination from '../shared/Pagination';
import PageHeader from '../shared/PageHeader';
import { url } from '../../services/utils';
// data stubs
import dataOrders from '../../data/accountOrders';
import theme from '../../data/theme';
import axios from 'axios';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

 class AddendumPageOrders extends Component {
    constructor(props) {
        super(props);

        this.state = {
            orders: [],
            page: 1,
        };
    }

    componentDidMount(){
        const{token} =this.props
        const usercode = localStorage.getItem('user_code');
        const getOnGoing= async () => {
            try {
                
                const result = await axios({
                    method: 'POST',
                    url: `${process.env.REACT_APP_HOST_API}/oa-revisi/page`,
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                    data:{
                        page:this.state.page,
                        per_page: 10,
                        user_code : usercode
                    }
                    
                  });
                  this.setState({ orders: result.data.response });
                    // console.log(this.state.orders);

            } catch (error) {
                // console.log(error);
        // toast.error('There was an error!');
            }
        }
        if(token){
            getOnGoing()
        }
    }

    // componentDidUpdate(){
    //     const{token} =this.props
    //     const getOnGoing= async () => {
    //         try {
    //             const result = await axios({
    //                 method: 'POST',
    //                 url: `${process.env.REACT_APP_HOST_API}/transaction/page`,
    //                 headers: {
    //                   Authorization: `Bearer ${token}`,
    //                 },
    //                 data:{
    //                     page:this.state.page,
    //                     per_page: 10
    //                 }
                    
    //               });
    //               this.setState({ orders: result.data?.response });
    //         } catch (error) {
    //             console.log(error);
    //     toast.error('There was an error!');
    //         }
    //     }
    //     if(this.state.page){
    //         getOnGoing()
    //     }
    // }

    handlePageChange = (page) => {
        this.setState(() => ({ page }));
        // console.log(this.state.orders);
    };

    renderItems() {
        // const {  cartRemoveItem } = this.props;
        const {token, dispatch} =this.props
        const { page, orders } = this.state;

        const ordersList = orders.map((order) => (
            <tr key={order.id}>
                <td><Link to="/account/orders/5">{`#${order.transaction_code}`}</Link></td>
                <td>{order.transaction_date}</td>
                <td>{order.bank_name}</td>
                <td>{order.transaction_total}</td>
                <td>{order.active_flag}</td>
            </tr>
        ));
        return orders.map((item) => {
            let options;

            const formatRupiah = (money) => {
                return new Intl.NumberFormat('id-ID',
                    { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }
                ).format(money);
              }

            return (
                <tr key={item.id} className="cart-table__row">
                    <td className="cart-table__column cart-table__column--kode">
                        <Link to={url.addendumdetail(item.id)} className="cart-table__kode-name">
                           <b> {item.addendum_code}</b>
                        </Link>
                        {options}
                    </td>
                    <td className="cart-table__column cart-table__column--tanggal" data-title="Tanggal">
                    {item.status === 1 ? "-":
                    item.status === 2 ? <b>{item.transaction_date}</b>:
                    item.status === 3 ? <b>{item.transaction_date}</b>:
                    item.status === 4 ? <b>{item.transaction_date}</b>:
                    item.status === 5 ? <b>{item.transaction_date}</b>:
                    item.status === 6 ? <b>{item.transaction_date}</b>:
                    <b>{item.transaction_date}</b>}
                    </td>
                    <td className="cart-table__column cart-table__column--bank" data-title="Jasa">
                        <b>{item.aplikator_name}</b>
                    </td>
                    {/* <td className="cart-table__column cart-table__column--totalbayar" data-title="Total">
                    {formatRupiah(item.transaction_total)}
                    </td> */}
                    <td className="cart-table__column cart-table__column--status" data-title="Status">
                    {
                        item.status === 1 ? <Badge color="warning" pill> Menunggu Perhitungan revisi </Badge>:
                        item.status === 2 ? <Badge color="warning" pill> Pembayaran</Badge>:
                        item.status === 3 ? <Badge color="warning" pill> </Badge>:
                        item.status === 4 ? <Badge color="warning" pill> Upload Bukti Bayar</Badge>:
                        item.status === 5 ? <Badge color="warning" pill> Menunggu validasi Pembayaran</Badge>:
                        <Badge color="warning" pill> Lunas </Badge>}
                    </td>
                    <td className="cart-table__column" data-title="">
                    {item.status === 1 ? "" 
                        // <div className="cart__buttons">
                        //         <Link to={url.alamatsurvey(item.id)} className="btn nav-bawah-mobile" style={{color:"white"}}>Masukan Alamat Survey</Link>
                        // </div>
                    :
                    item.status === 2 ? 
                    <div className="cart__buttons">
                            <Link to={url.cekdetailrevisi(item.id)} className="btn nav-bawah-mobile" style={{color:"white"}}>Detail Revisi</Link>
                    </div>
                    :
                    item.status === 3 ?  
                        ""
                    :
                    item.status === 4 ? 
                    <div className="cart__buttons">
                            <Link to={url.buktibayaraddendum(item.id)} className="btn nav-bawah-mobile" style={{color:"white"}}>Bukti Bayar</Link>
                    </div>
                    :
                    item.status === 5 ?
                    "" : ""}
                    </td>
                </tr>
            );
        });
    }

    renderCart() {
        // const { cart, cartUpdateQuantities } = this.props;
        const { quantities, payment, cart_id, loadingCO} = this.state;

        return (
            <div className="cart block">
                <div className="container">
                    <table className="cart__table cart-table">
                        <thead className="cart-table__head">
                            <tr className="cart-table__row">
                                <th className="cart-table__column cart-table__column--kode">Kode</th>
                                <th className="cart-table__column cart-table__column--tanggal">Tanggal</th>
                                <th className="cart-table__column cart-table__column--bank">Jasa Aplikator</th>
                                <th className="cart-table__column cart-table__column--status">Status</th>
                                <th className="cart-table__column "></th>

                                {/* <th className="cart-table__column cart-table__column--remove" aria-label="Remove" /> */}
                            </tr>
                        </thead>
                        <tbody className="cart-table__body">
                            {this.renderItems()}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    render1() {
        const { page, orders } = this.state;

        const ordersList = orders.map((order) => (
            <tr key={order.id}>
                <td><Link to="#">{`#${order.transaction_code}`}</Link></td>
                <td>{order.transaction_date}</td>
                <td>{order.bank_name}</td>
                <td>{order.transaction_total}</td>
                <td>{order.active_flag}</td>
            </tr>
        ));

        return (
            <div className="card">
                <Helmet>
                    <title>{`Riwayat Pesanan Jasa | ${theme.name}`}</title>
                </Helmet>

                <div className="card-header">
                    <h5>Histori</h5>
                </div>
                <div className="card-divider" />
                <div className="card-table">
                    <div className="table-responsive-sm">
                        {this.state.orders === null ? (
                             <table>
                             <thead>
                                 <tr>
                                     <th>Kode</th>
                                     <th>Tanggal</th>
                                     <th>Bank</th>
                                     <th>Total</th>
                                     <th>Status</th>
                                 </tr>
                             </thead>
                             <tbody>
                                 Data Kosong
                             </tbody>
                         </table>
                        ):(
                            <table>
                            <thead>
                                <tr>
                                    <th>Kode</th>
                                    <th>Tanggal</th>
                                    <th>Bank</th>
                                    <th>Total</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ordersList}
                            </tbody>
                        </table>
                        )
                        }
                    </div>
                </div>
                <div className="card-divider" />
                <div className="card-footer">
                    <Pagination current={page} onPageChange={this.handlePageChange} />
                </div>
            </div>
        );
    }

    render() {
        const { orders } = this.state;
        const breadcrumb = [
            { title: 'Home', url: '' },
            { title: 'Keranjang', url: '' },
        ];

        let content;

        if (orders.length>0) {
            content = this.renderCart();
        } else {
            content = (
                <EmptyState icon="file-signature" title="Belum ada revisi pesanan" text="Revisi pesanan jasa akan tampil di sini." actionLabel="Ke Beranda" actionTo="/" actionIcon="home" />
            );
        }
// console.log(this.state.quantities)
        return (
            <React.Fragment>
                <Helmet>
                    <title>{`Revisi Pesanan Jasa | ${theme.name}`}</title>
                </Helmet>
                <br></br>
                <PageHeader header="Revisi Pesanan Jasa" />
                {content}
            </React.Fragment>
        );
    }
    
}

const mapStateToProps = (state) => ({
    token: state.auth.token,
  });
  
  const mapDispatchToProps = {};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(AddendumPageOrders)